module.exports = __webpack_public_path__ + "img/liquidation@2x.f979cbfb.png";